import { Search } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  onSubmit?: () => void;
  placeholder?: string;
  className?: string;
}

export default function SearchBar({ value, onChange, onSubmit, placeholder, className = '' }: SearchBarProps) {
  const { t } = useTranslation();
  
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit?.();
  };
  
  return (
    <form onSubmit={handleSubmit} className={`relative flex items-center ${className}`}>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder || t('search.placeholder')}
        className="w-full h-10 pl-4 pr-10 bg-neutral-100 border border-transparent rounded-lg 
          text-neutral-800 placeholder:text-neutral-500
          focus:bg-white focus:border-primary-300 focus:ring-4 focus:ring-primary-100
          hover:bg-neutral-50"
      />
      <button 
        type="submit"
        className="absolute right-2 p-2 text-neutral-400 hover:text-primary-600"
      >
        <Search className="h-5 w-5" />
      </button>
    </form>
  );
}